import { Controller } from 'stimulus';

export default class extends Controller {
  submit(event) {
    event.preventDefault()
    const form = this.element
    
    fetch(form.action, {
      method: form.method,
      body: new FormData(form),
      headers: {
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
        'Accept': 'application/json'
      },
      credentials: 'same-origin'
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        // Show success toastr notification
        if (typeof toastr !== 'undefined') {
          toastr.success('Permission updated successfully');
        }
      } else {
        // Show error toastr notification
        if (typeof toastr !== 'undefined') {
          toastr.error('Error updating permission');
        }
      }
    })
    .catch(error => {
      console.error('Error:', error)
      if (typeof toastr !== 'undefined') {
        toastr.error('Error updating permission');
      }
    })
  }
}